import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp, formatDate } from "../../../utils/common";
import { useTranslation } from "react-i18next";
import useMainContentDimensions from "../../../utils/mainContentDimensions";

import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  CardContent,
  Box,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "../../../components/Toolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import useAuth from "../../../hooks/useAuth";
import usePaymentProcess from "../../../hooks/usePaymentProcess";
import AdvanceFilter from "./components/AdvanceFilter";
import RefreshPaymentStatus from "./components/RefreshPaymentStatus";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function PaymentGatewayReport(props) {
  const { user } = useAuth();
  console.log(user, "llllllllllllll");
  const { isLoadingDownload, downloadFileType } = usePaymentProcess();
  const { width: mainContentWidth } = useMainContentDimensions();

  const { state } = useLocation();
  const { t } = useTranslation();

  const { radUserId } = props;

  const today = formatDate(new Date());

  const currentPayload = {
    filters: [
      {
        fieldName: "createdAt",
        fieldValue: `${today} 00:00:00,${today} 23:59:59`,
        op: "btn",
        dataType: "date",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  useEffect(() => {
    if (radUserId != undefined) {
      const payloadValues = {
        ...currentPayload,
        filters: [
          ...currentPayload.filters,
          {
            fieldName: "radUserId",
            fieldValue: radUserId,
            op: "eq",
            dataType: "int",
            condition: "and",
            isJoin: true,
            attributeName: "radUser",
            entityName: "RadUserEntity",
          },
        ],
      };
      setPayload(payloadValues);
    } else {
      setPayload(currentPayload);
    }
    setPaginationModel({
      page: 0,
      pageSize: 100,
    });
  }, [radUserId]);

  useEffect(() => {
    if (user != undefined && user.businessType == "USER") {
      const payloadValues = {
        ...currentPayload,
        filters: [
          ...currentPayload.filters,
          {
            fieldName: "radUserId",
            fieldValue: user.radUserId,
            op: "eq",
            dataType: "int",
            condition: "and",
            isJoin: true,
            attributeName: "radUser",
            entityName: "RadUserEntity",
          },
        ],
      };
      setPayload(payloadValues);
    } else {
      setPayload(currentPayload);
    }
  }, [user]);

  const [selectedRows, setSelectedRows] = useState([]);

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const [filterFormData, setFilterFormData] = useState({
    transDate: [new Date(), new Date()],
    transDateStr: `${today} 00:00:00,${today} 23:59:59`,
  });
  const { height } = useWindowDimensions();
  const { getAllPaymentProcess, paymentProcesses, paging, downloadFile } = usePaymentProcess();
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState({});

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const fetchData = async () => {
    if (Object.keys(payload).length != 0) {
      await getAllPaymentProcess(payload);
    }
  };

  const refreshPage = () => {
    if (radUserId != undefined) {
      const payloadValues = {
        ...currentPayload,
        filters: [
          ...currentPayload.filters,
          {
            fieldName: "radUserId",
            fieldValue: radUserId,
            op: "eq",
            dataType: "int",
            condition: "and",
            isJoin: true,
            attributeName: "radUser",
            entityName: "RadUserEntity",
          },
        ],
      };
      setPayload(payloadValues);
      setFilterFormData({
        transDate: [new Date(), new Date()],
        transDateStr: `${today} 00:00:00,${today} 23:59:59`,
      });
    } else {
      setPayload(currentPayload);
      setFilterFormData({
        transDate: [new Date(), new Date()],
        transDateStr: `${today} 00:00:00,${today} 23:59:59`,
      });
    }
    filterResetFunc();
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Reports</Typography>
        <Typography>Payment Gateway</Typography>
      </Breadcrumbs>
    );
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const columns = [
    {
      field: "invoiceNo",
      headerName: "Invoice No",
      width: 130,
    },
    {
      field: "orderId",
      headerName: "Order Id",
      width: 200,
    },
    {
      field: "paymentId",
      headerName: "Payment Id",
      width: 130,
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 150,
    },
    {
      field: "userFullName",
      headerName: "User FullName",
      width: 150,
    },
    {
      field: "tenantName",
      headerName: "Franchise Name",
      width: 200,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 150,
    },
    {
      field: "transDate",
      headerName: "Transaction Date",
      width: 200,
    },
    {
      field: "createdBy",
      headerName: "Payment Done By",
      width: 150,
    },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      width: 150,
    },
    {
      field: "isSchedule",
      headerName: "Schedule Status",
      width: 150,
    },
    {
      field: "paymentGatewayName",
      headerName: "Gateway Name",
      width: 150,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
        filterFormData={filterFormData}
        setFilterFormData={setFilterFormData}
      />,
      "md",
    );
  };

  const exportFile = async (fileType) => {
    await downloadFile(fileType, payload);
  };

  const refreshPaymentStatus = () => {
    return openDialog(
      "refresh_payment_status",
      "Refresh Payment Status",
      <RefreshPaymentStatus
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        refreshPage={refreshPage}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            downloadFile={exportFile}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
            refreshPaymentStatus={refreshPaymentStatus}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {t("payment_gateway_reports")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DataGrid
            columns={columns}
            rows={paymentProcesses}
            refreshPage={fetchData}
            getRowId={(row) => row["paymentTransId"]}
            rowCount={paging.totalNumberOfRecords}
            loading={false}
            rowsPerPageOptions={[5]}
            pagination
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMode="server"
            onPaginationModelChange={onPageChange}
            onPageSizeChange={(pageSize) => onPageChange(pageSize)}
            checkboxSelection
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": {
                backgroundColor: "#f9f9f9", // Light gray for even rows
              },
              "& .MuiDataGrid-row.odd-row": {
                backgroundColor: "#ffffff", // White for odd rows
              },
            }}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setSelectedRows(newRowSelectionModel);
            }}
            rowSelectionModel={selectedRows}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default PaymentGatewayReport;
